
// make sticky the filters in the collection pages
(() => {
  try {
    const sentinel = document.querySelector('.template-collection facet-filters-form');
    const stickyElement = document.querySelector('.template-collection .facets-vertical .facets-wrapper');

    if (!sentinel || !stickyElement) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (window.innerWidth < 990) return;
        if (!entry.isIntersecting) {
          stickyElement.classList.add("margin-added");
        } else {
          stickyElement.classList.remove("margin-added");
        }
      },
      { root: null, threshold: 0 }
    );

    observer.observe(sentinel);
  } catch (e) {
    console.error("Sticky observer setup failed:", e);
  }
})();
// end sticky

// Mobile menu collaps
document.addEventListener('DOMContentLoaded', function() {
  if(window.innerWidth < 768){
    const headers = document.querySelectorAll('.footer-menu-header');

    headers.forEach(header => {
      header.addEventListener('click', function() {
        const list = header.nextElementSibling; // the UL
        const isOpen = list.style.display === 'block';
        list.style.display = isOpen ? 'none' : 'block';
        header.classList.toggle('active', !isOpen); // arrow rotation
      });
    });
  }

  window.addEventListener('resize', function() {
    if(window.innerWidth >= 768){
      document.querySelectorAll('.footer-block__details-content').forEach(ul => {
        ul.style.display = 'block';
      });
      document.querySelectorAll('.footer-menu-header').forEach(header => {
        header.classList.remove('active');
      });
    } else {
      // Optional: collapse again when switching to mobile
      document.querySelectorAll('.footer-block__details-content').forEach(ul => {
        ul.style.display = 'none';
      });
      document.querySelectorAll('.footer-menu-header').forEach(header => {
        header.classList.remove('active');
      });
    }
  });
});

